import {useInfiniteQuery} from "@tanstack/react-query";
import {PaginatedResponseType} from "../Types/Response/PaginatedResponseType";
import axiosAuthorised from "./AxiosAuthorised";
import { PaginationPageParameters } from "./PaginationHelpers";

const getShippingOptions = async (countryCode: string, width: number, length: number, depth: number, weight: number) => {
    const baseUrl = `${process.env.REACT_APP_API_HOST}/mobile/v1/shipping-cost/list?offset=0&limit=50&countrycode=${countryCode}&width=${width}&depth=${depth}&length=${length}&weight=${weight}`;
    return await axiosAuthorised.get(baseUrl).then(r => r.data);
}

const useInfiniteShippingCostPresets = () => {
    const baseUrl = `${process.env.REACT_APP_API_HOST}/mobile/v1/shipping-cost/preset-size/list?offset=0&limit=20`;

    return useInfiniteQuery(
        ['shipping-cost-presets'],
        async ({ pageParam = baseUrl }) => {
            const { data } : { data: PaginatedResponseType } = await axiosAuthorised.get(pageParam);
            return data;
        },
        {
            ...PaginationPageParameters,
            staleTime: 600000,
            refetchOnWindowFocus: false
        },
    );
}

export { useInfiniteShippingCostPresets, getShippingOptions }